import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import SmoothCollapse from 'react-smooth-collapse';
import ChevronDownIcon from 'calcite-ui-icons-react/ChevronDownIcon';

import MapController from '../../../../controllers/MapController';
import { layers } from '../../../../config/layers.config';

import { RootState } from '../../../../reducers/app';

import './my-layer.scss';
import LayerTooltip from './layer-tooltip';
import InfoSvg from '../../../../assets/info-icon';

const TreeCoverLayer = ({ layer }: { layer: any }) => {
  // LOCAL STATE
  const [sectionOpen, setSectionOpen] = useState<boolean>(false);
  const [symbology, setSymbology] = useState<Array<{ imageURL: string; name: string }>>([]);

  // REDUX
  const visibleLayers = useSelector((state: RootState) => state.mapview.visibleLayers);

  // REFS

  useEffect(() => {
    const tclddRenderingRule = layers.find((l) => l.options.id === 'tree-cover-loss-by-dominant-driver')?.options
      .renderingRule;
    const url = `${layer.url}/legend/?bandIds=&renderingRule=${JSON.stringify({ rasterFunction: tclddRenderingRule.functionName })}&f=pjson`;
    try {
      fetch(url)
      .then((res) => res.json())
      .then((res) => {
        if (res.error) {
          console.error("Error fetching TCLDD legend", res.error)
          return;
        }
        const legends = res.layers[0].legend.map((legend: any) => {
          return { imageURL: legend.imageData, name: legend.label };
        });
        setSymbology(legends);
      });
    } catch (e) {
      console.error("Error fetching TCLDD legend", e)
    }
  }, [layer.url]);

  return (
    <div className='layer-container' key={layer.id}>
      <div className='layer'>
        <div className='layer-title__wrapper'>
          <input
            type='checkbox'
            id={layer.id}
            name={layer.id}
            checked={visibleLayers.includes(layer.id)}
            onChange={() => MapController.updateLayerVisibility(layer.id, !visibleLayers.includes(layer.id))}
          />
          <div className='layer-title'>{layer.title}</div>
        </div>
        <div className='tools'>
          {layer.description && layer.description.length > 0 && (
            <LayerTooltip tip={layer.description}>
              <InfoSvg />
            </LayerTooltip>
          )}
          <ChevronDownIcon
            className={sectionOpen ? 'open' : ''}
            size={24}
            onClick={() => setSectionOpen(!sectionOpen)}
          />
        </div>
      </div>
      <SmoothCollapse className='hansen-container' expanded={sectionOpen} allowOverflowWhenOpen eagerRender={true}>
        {/* <div ref={legendContainerRef} /> */}
        {symbology.map((symbol) => {
          return (
            <div className='tcldd-legend' key={symbol.name}>
              <div
                className='legend__symbol'
                style={{ backgroundImage: `url(data:image/png;base64,${symbol.imageURL})` }}
              />
              <div className='legend__name'>{symbol.name}</div>
            </div>
          );
        })}
      </SmoothCollapse>
    </div>
  );
};

export default TreeCoverLayer;
